module.exports = __webpack_public_path__ + "static/media/Main_subcontent3.8e55c465.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/Main_subcontent3.jpeg
// module id = 214
// module chunks = 0